import React, {Component} from 'react';
import styled from 'styled-components';
import bgMobile from '../../assets/img/homeBGMobile.jpg'
import bg from '../../assets/img/homeBG.jpg';
import {HeroContainer, SectionContainer} from "../Container/Container";

const Container = HeroContainer.extend`
 background: url("${bgMobile}") no-repeat;
 
 @media(min-width: 500px){
    background: url("${bg}") no-repeat bottom;
    background-size: cover;
 }

`;

const StyledSectionContainer = styled(SectionContainer)`
  display: grid;
  grid-row-gap: 12px;
  grid-template-columns: 1fr;
  
  @media(min-width: 500px){
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  
  @media(min-width: 768px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const TextContainer = styled.div`
  @media(min-width: 1200px) {
    padding-left: 50px;
  }
`;

const HeroImg = styled.img`
  width: 100%;
`;

const StyledTitle = styled.h1`
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  font-family: Cabin-Bold, sans-serif;
  font-size: 36px;
  margin-bottom: 10px;
  
  @media(min-width: 500px) {
    text-align: left;
  }
 
  @media (min-width: 768px) {
     font-size: 26px;
  }
  
  @media(min-width: 992px) {
    font-size: 40px;
  }
  
   @media(min-width: 1200px) {
    font-size: 50px;
  }
  
   @media(min-width: 1680px) {
    font-size: 68px;
  }
`;

const Subtitle = styled.p`
  color: #fff;
  font-family: Cabin, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  z-index: 1;
  
   @media(min-width: 500px) {
    text-align: left;
  }
  
   @media(min-width: 992px) {
    font-size: 23px;
  }
  
 
`;

class HomeHeader extends Component {
    render() {
        const {header, paragraph, image} = this.props.data;
        return (
          <Container>
              <StyledSectionContainer>
                  <TextContainer>
                      <StyledTitle>{header}</StyledTitle>
                      <Subtitle>{paragraph}</Subtitle>
                  </TextContainer>
                  <HeroImg src={image.source_url} alt={image.alt}/>
              </StyledSectionContainer>
          </Container>
        );
    }
}

export default HomeHeader;








// WEBPACK FOOTER //
// ./src/components/Home/HomeHeader.js